import React, { Component, Fragment } from 'react';

import { Column } from 'react-virtualized';

import defaultRowRenderer from 'components/shared/ReactVirtualizedTable/DefaultRowRenderer';
import ReactVirtualizedTable from 'components/shared/ReactVirtualizedTable';
import { VisitorStatus } from 'components/shared/StatusHelper';

import { toFriendlyDateTimeString } from 'helpers/Formatter';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

class VisitorsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      rowData: {},
    };
  }

  handleClick = (event, rowData) => {
    this.setState({ anchorEl: event.currentTarget, rowData: rowData });
  };

  handleClose = () => {
    this.setState({ anchorEl: null, rowData: {} });
  };

  changeStatus = statusName => {
    let visitorData = this.state.rowData;
    if (statusName === 'checked_in') {
      visitorData['check_in'] = true;
    } else {
      visitorData['check_out'] = true;
    }
    this.props.createOrUpdateVisitor(visitorData, visitorData.id).then(() => {
      this.handleClose();
    });
  };

  toggleVisitorDetailsDialog = (event, rowData) => {
    // Because we have two onClick functions (one for the row, and one for
    // the row button), we want to prevent both from triggering
    if (event._dispatchListeners.length === 2) return;
    this.props.toggleVisitorDetailsDialog(rowData);
  };

  render() {
    const { anchorEl } = this.state;

    const VISITOR_STATUSES = ['checked_in', 'checked_out'];

    return (
      <Fragment>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {VISITOR_STATUSES.map((statusName, index) => (
            <MenuItem
              onClick={() => this.changeStatus(statusName)}
              disabled={statusName === this.state.rowData.status}
              selected={statusName === this.state.rowData.status}
              key={index}
            >
              <span>{<VisitorStatus status={statusName} />}</span>
            </MenuItem>
          ))}
        </Menu>
        <ReactVirtualizedTable
          data={this.props.data}
          rowRenderer={defaultRowRenderer}
          onRowClick={({ rowData, event }) => this.toggleVisitorDetailsDialog(event, rowData)}
          grouped
        >
          <Column
            width={125}
            label="Status"
            dataKey="status"
            cellRenderer={({ cellData, rowData }) => (
              <Button
                aria-owns={anchorEl ? 'simple-menu' : null}
                aria-haspopup="true"
                onClick={event => this.handleClick(event, rowData)}
                style={{ padding: 0 }}
                disabled={rowData['status'] === 'checked_out'}
              >
                <span>{<VisitorStatus status={cellData} />}</span>
              </Button>
            )}
          />
          <Column
            width={125}
            label="Visiting"
            dataKey="unit_number"
            cellRenderer={({ cellData }) => (cellData ? `Unit ${cellData}` : 'Entire Building')}
          />
          <Column width={200} label="Name" dataKey="full_name" />
          <Column
            width={200}
            label="Expected Arrival Date"
            dataKey="expected_arrival_at"
            cellRenderer={({ cellData }) => toFriendlyDateTimeString(cellData)}
          />
          <Column
            width={200}
            label="Expected Departure Date"
            dataKey="expected_departure_at"
            cellRenderer={({ cellData }) => toFriendlyDateTimeString(cellData)}
          />
        </ReactVirtualizedTable>
      </Fragment>
    );
  }
}

export default VisitorsTable;
